import queryString from 'query-string';

import { URLS } from 'rebook/apps/base/constants';
import { SEARCH_SEARCH_LINE_SET_DATA } from 'rebook/apps/search/constants';


export function initQuery(history) {
  // set up initial state from current location
  return (dispatch) => {
    const queryObj = queryString.parse(history.location.search);

    if (queryObj.q && history.location.pathname === URLS.search) {
      dispatch(updateQuery(queryObj.q, history));
    }
  };
};

export function updateQuery(query, history) {
  return (dispatch, getState) => {
    const { lastLocation, value } = getState().searchQuery;
    let updatedState = {
      value: query,
      isActive: true,
      isLoading: false,
    };

    // remember the current location before redirecting the user to search view
    if (!lastLocation) {
      updatedState.lastLocation = history.location;
    }
    if (query !== value) {
      updatedState.isLoading = true;
    }

    dispatch(setQueryData(updatedState));
    if (query && query.length >= 3) {
      // update browser location url, so it can be copy-pasted
      history.push({
        ...history.location,
        pathname: '/search/',
        search: `?q=${query}`,
      });
    }
  };
};

export function cancelQuery(history) {
  // clear and deactivate the search line
  return (dispatch, getState) => {
    const { lastLocation } = getState().searchQuery;

    dispatch(setQueryData({
      value: null,
      isActive: false,
      lastLocation: null,
      isLoading: false,
    }));

    // return the user to the page she was before entering the search view
    if (lastLocation && history) {
      history.push(lastLocation);
    }
  };
};

export function setLoadingStatus(isLoading = false) {
  return (dispatch) => {
    dispatch(setQueryData({
      isLoading,
    }));
  };
};

export default function setQueryData(payload) {
  return {
    type: SEARCH_SEARCH_LINE_SET_DATA,
    payload,
  };
};
